<template>
    <ion-page>
        <standard-header title="Lists" align="middle"/>
        <ion-content :fullscreen="true">
            <pull-down-refresh :callback="refresh"/>
            <skeleton :rows="4" v-if="shipments === null"/>
            <div v-show="shipments && shipments.length < 1">
                <no-results title="No Results">
                    No lists available
                </no-results>
            </div>
            <div v-if="shipments !== null">
                <ion-list>
                    <div v-for="shipment in shipments" :key="shipment.id">
                        <ion-item detail button @click.stop="goToShipment(shipment)" lines="none">
                            <pick-list-item
                                :shipment="shipment"
                                :completed="shipment.is_checked"
                                :duration-source="shipment.checkers"
                            />
                        </ion-item>
                        <ion-progress-bar :value="shipment.pc_complete/100" />
                    </div>
                </ion-list>
            </div>
        </ion-content>
        <ion-footer>
            <ion-button
                expand="block"
                color="primary"
                size="large"
                @click="createNewList"
            >Create New</ion-button>
        </ion-footer>
    </ion-page>
</template>

<script>
import {
    IonContent,
    IonItem,
    IonList,
    IonPage,
    IonProgressBar,
    IonFooter,
    IonButton,
    modalController
} from '@ionic/vue';
import StandardHeader from "@/components/StandardHeader.vue";
import NoResults from "@/components/NoResults";
import Skeleton from "@/components/Skeleton";
import PullDownRefresh from "@/components/PullDownRefresh";
import CreateListModal from '@/views/modules/lists/pages/CreateModal';
import {checkmarkCircleOutline} from 'ionicons/icons';
import PickListItem from "@/views/modules/picking/components/PickListItem";

export default {
    inject: ['$http'],
    name: 'ListsList',
    components: {
        PickListItem,
        PullDownRefresh,
        Skeleton,
        NoResults,
        StandardHeader,
        IonContent, IonPage, IonItem, IonList, IonProgressBar, IonFooter, IonButton
    },
    data() {
        return {
            shipments: null,
        }
    },
    methods: {
        createNewList() {
            modalController.create({
                component: CreateListModal
            }).then(m => {
                m.present();
                m.onDidDismiss().then(data => {
                    if (data && data.data && data.data.refresh) {
                        this.refresh();
                    }
                });
            });
        },
        goToShipment(shipment) {
            modalController.create({
                component: CreateListModal,
                componentProps: {
                    value: shipment
                }
            }).then(m => {
                m.present();
                m.onDidDismiss().then(data => {
                    if (data && data.data && data.data.refresh) {
                        this.refresh();
                    }
                });
            });
        },
        ionViewDidEnter() {
            this.refresh();
        },
        refresh(event = null) {
            this.$http.get('/api/shipments', {params: {
                include: 'lines',
                search: 'stage:config;is_list:1',
                searchJoin: 'and'
            }}).then(response => {
                this.shipments = response.data.items;
            }).catch(error => {
                this.$validationAlert(error);
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
            });
        }
    },
    setup() {
        return {checkmarkCircleOutline};
    }
}
</script>
